<template>
    <div>
        <b-modal size="lg" id="comission" title="Komisyon Excel Yükleme" no-close-on-esc no-close-on-backdrop>
            <upload-komisyon v-model="uploadObject" :result="uploadResult" :save-result="saveResult"></upload-komisyon>
            <template #modal-footer><v-executer :action="saveResult != null ? done : canCreateMultiple ? upload : check" :loading="uploading">{{saveResult != null ? 'Tamam' : canCreateMultiple ? "Kaydet" : "Kontrol Et"}}</v-executer></template>
        </b-modal>

        <b-modal size="lg" id="comission-history" title="Komisyon Yükleme Takibi" body-class="p-0">
            <commission-upload-history />
            <template #modal-footer><div></div></template>
        </b-modal>
        
        <v-mu-picker ref="picker" :code="$safe(muhasebe,'MuhasebeKodu')" v-on:pick="onPickMuhasebe"/>

        <div class="row">
            <div class="col-lg-4">
                <b-card class="p-1" no-body>
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox v-model="remember">Seçimleri Hatırla <br/><small>(Kasa, Gelir/Gider, Tarih, Proje Kodu)</small></b-form-checkbox>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa</label>
                            <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                                <v-select-list   v-model="kasa" v-on:input="getKasaDovizDeger" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Gelir/Gider</label>
                            <v-validator :errors="errors" parameter="VaultActionType" :watch="gcType">
                                <v-select-list v-model="gcType" label="Name" v-on:input="getKasaHareketToday" :options="gcTypes" placeholder="Gelir/Gider" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12">
                            <div class="mb-1" v-if="pleaseWait">
                                <span class="text-success">Döviz bilgileri getiriliyor. Lütfen Bekleyiniz... </span>
                            </div>
                            <v-validator :errors="errors" parameter="CurrencyRate" :watch="model.CurrencyRate">
                                <div class="table-responsive" v-if="currencyRateObj != null &&!pleaseWait && currencyRateObj.CurrencyType && model.CurrencyType != null">
                                    <table class="table table-sm table-bordered mb-0" width="100%">
                                        <tbody>
                                            <tr>
                                                <th>Döviz Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizAlis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.DovizAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizSatis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.DovizSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffAlis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.EffAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffSatis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.EffSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType != null && model.CurrencyType != 0">
                            <label class="form-label" >Döviz Tutar</label>
                            <v-validator :errors="errors" parameter="CurrencyAmount" :watch="model.CurrencyAmount">
                                <v-currency-input  v-on:input="calculateValue" input-class="text-right" :value="model.CurrencyAmount" v-on:update-value="currencyAmount => model.CurrencyAmount = currencyAmount"></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType == 0 || model.CurrencyType == null">
                            <label class="form-label" >Tutar</label>
                            <v-validator :errors="errors" parameter="Amount" :watch="model.Amount">
                                <v-currency-input  input-class="text-right" :value="model.Amount" v-on:update-value="amount => model.Amount = amount"></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Tarih</label>
                            <v-validator :errors="errors" parameter="EffectiveDate" :watch="model.EffectiveDate">
                                <v-date-picker v-model="model.EffectiveDate" placeholder="Tarih"/>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Muhasebe Kodu</label>
                            <div class="d-flex g-50">
                                <v-validator :errors="errors" parameter="MuhasebeKarsilikKodu" :watch="muhasebe">
                                    <input class="form-control" :value="$safe(muhasebe,'MuhasebeKodu')" readonly disabled placeholder="Muhasebe Kodu"/>
                                </v-validator>
                                <button class="btn btn-outline-primary text-nowrap" v-on:click="$refs.picker.pick()">Hesap Seç</button>
                            </div>
                            <small>{{ $safe(muhasebe,'MuhasebeAdi') }}</small>
                        </div>               
                        <div class="col-12 mb-1">
                            <label class="form-label">Proje Kodu</label>
                            <v-validator :errors="errors" parameter="ProjectCode" :watch="projectCode">
                                <v-select-list v-model="projectCode" :options="projectCodes" label="label" placeholder="Proje Kodu" ></v-select-list>
                            </v-validator>
                        </div>
                        <!-- <div class="col-12 mb-1">
                            <label class="form-label">Plasiyer</label>
                            <v-validator :errors="errors" parameter="PlasiyerCode" :watch="plasiyerCode">
                                <v-select-list v-model="plasiyerCode"  label="PlasiyerInformation" :options="plasiyerList" placeholder="Plasiyer" ></v-select-list>
                            </v-validator>
                        </div> -->
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa Rapor Açıklama</label>
                            <v-validator :errors="errors" parameter="KasaRapor_Kodu" :watch="reportCode">
                                <v-select-list v-model="reportCode" :options="reportCodes" label="Code" placeholder="Kasa Rapor Açıklama" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa Açıklaması</label>
                            <v-validator :errors="errors" parameter="VaultDescription" :watch="model.VaultDescription">
                                <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="Kasa Açıklaması" v-model="model.VaultDescription"></textarea>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">TMS Kasa Açıklaması</label>
                            <v-validator :errors="errors" parameter="TMSVaultDescription" :watch="model.TMSVaultDescription">
                                <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="TMS Kasa Açıklaması" v-model="model.TMSVaultDescription"></textarea>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Belge Türü</label>
                            <v-validator :errors="errors" parameter="BelgeTuru" :watch="belgeTuru">
                                <v-select-list :options="belgeTurus" label="Name" placeholder="Belge Türü" v-model="belgeTuru"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 text-right">
                            <v-executer :loading="saveLoading" :action="save"> Kaydet </v-executer>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-8">
                <b-card no-body>
                    <v-table    ref="table"
                                name="vault-actions"
                                with-items
                                :settings="false"
                                :fields="fields"
                                :buttons="buttons"
                                search
                                :items="kasaHareketToday">
                                <template #additional-actions>
                                    <div class="w-100 d-flex align-items-center">
                                        <h4 class="mb-0">Bugünkü Hareketler</h4>
                                        <b-dropdown v-if="kasa" class="ml-auto" variant="primary" text="İşlemler">
                                            <b-dropdown-item v-on:click="openUpload">Komisyon Excel Yükleme</b-dropdown-item>
                                            <b-dropdown-item v-on:click="download">Komisyon Excel Örneği</b-dropdown-item>
                                            <b-dropdown-item v-on:click="openHistory">Komisyon Yükleme Takibi</b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                </template>
                            </v-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard,BFormInput,BFormRadio,BOverlay,BDropdown, BDropdownItem,BFormCheckbox } from 'bootstrap-vue'
import NetsisOperationsApi from '@/api/netsis-operations'
import VaultOperationsApi from '@/api/vault-operations'
import Auth from '@/utilities/auth'

import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VExecuter from '@/components/VExecuter.vue'
import { printFis } from '../components/fis/print-fis';
import Additional from '@/utilities/additional'
import UploadKomisyon from './components/UploadKomisyon.vue';
import VMuPicker from '@/components/VMuPicker.vue';
import { printTediyeFis } from '../components/fis/print-tediye-fis';
import moment from 'moment'
import CommissionUploadHistory from './components/CommissionUploadHistory.vue'

export default {
    components:{
        BDropdown, 
        BDropdownItem,
        BCard,
        BFormRadio,
        VCurrencyInput,
        BFormInput,
        VExecuter,
        BOverlay,
        UploadKomisyon,
        VMuPicker,
        BFormCheckbox,
        CommissionUploadHistory
    },
    data(){
        return{
            remember:false,
            errors:{},
            saveLoading:false,
            muhasebe:null,
            searchOnTableTimer:null,
            projectCodes:[
                {value:'R',label:'Banka 1'},
                {value:'G',label:'Banka 2'},
            ],
            gcTypes:[{Name:'Gelir',Value:'G'},{Name:'Gider',Value:'C'}],
            bForms:[{Name:`B Formu'na Dahil Değil`,Value:1},{Name:`B Formu'na Dahil`,Value:2},{Name:`B Formu'na Dahil (e-Belge)`,Value:3}],
            belgeTurus:[],
            reportCodes:[],
            fields:[
                { name:'Kasa Kodu',key:'KSMAS_KOD', tdClass:'text-nowrap',thClass:'w-6'},
                { name:'Kasa Adı',key:'KSMAS_NAME',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tarih',key:'TARIHStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Zaman',key:'ZAMAN',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'G/Ç',key:'IO',thClass:'w-7', tdClass:'text-nowrap'},
                { name:'Fiş No',key:'FIS_NO',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tip',key:'TIP',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Açıklama',key:'ACIKLAMA',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'TMS Açıklama',key:'TMSVaultDescription',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tutar',key:'TUTARStr', tdClass:'text-nowrap text-right',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:'Cari/Muh',key:'CARI_MUH', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Kod',key:'KOD',thClass:'w-7', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Cari Adı',key:'CARI_ISIM',thClass:'w-7', tdClass:'text-nowrap '},
                { name:'Muh. Adı', key:'MUH_ADI', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Plasiyer Adı',key:'PLASIYER_ISIM',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Şube Adı',key:'SUBE_ADI', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            buttons:[
                { text:"Fiş Yazdır",key:"fis",icon:"PrinterIcon",variant:"primary",action:this.print, },
                { text:"Yevmiye Fişi Yazdır",key:"ted-fis",icon:"PrinterIcon",variant:"secondary",action:this.printTediye },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.deleteHareket },
                
            ],
            model:{
                MuhasebeKarsilikKodu:null,
                MuhasebeKarsilikAdi:null,
                CurrencyAmount:0,
                Amount:0,
                VaultDescription: null,
                TMSVaultDescription: null,
                PlasiyerCode:null,
                PlasiyerName:null,
                ProjectCode:null,
                VaultActionType:null,
                VaultCode:null,
                VaultName:null,
                CurrencyType:null,
                IsCurrency:null,
                CurrencyRate:null,
                BFormStatus:null,
                BelgeTuru:null,
                EffectiveDate:moment().format('YYYY-MM-DD'),
            },
            pleaseWait: false,
            plasiyerLoading:false,
            kasaLoading:false,
            plasiyerList:[],
            kasaList:[],
            currencyRateObj:{
                CurrencyType:null,
                Date:null,
                DovizAlis:null,
                DovizSatis:null,
                EffAlis:null,
                EffSatis:null,
                DovizAliStr:null,
                DovizSatisStr:null,
                EffAlisStr:null,
                EffSatisStr:null,
            },
            calculatedValue:0,
            kasaHareketToday:[],
            uploading:false,
            uploadObject:{
                File:null
            },
            uploadResult:null,
            saveResult:null
        }
    },
    watch:{
        "uploadObject.File"(){
            this.uploadResult = null
        },
        "kasa"(){
            this.uploadResult = null
        }
    },
    mounted(){
        this.getKasaList()
        this.getBelgeTurus()
        this.getReportCodes()
        this.getKasaHareketToday()

    },
    methods:{
        getKasaHareketToday(){
            this.$refs.table.setLoading(true)
            NetsisOperationsApi.GetMuhtelifKasaHareketToday().then((res)=>{
                this.kasaHareketToday = res.data.Data
                this.$refs.table.setLoading(false)
            }).catch(err=> {
                this.$refs.table.setLoading(false)
                console.log(err)
            })
        },
        getReportCodes(){
            NetsisOperationsApi.ReportCode.List().then(res => {
                if(res.data.Success){
                    this.reportCodes = res.data.Data || []
                }
            })
        },
        clearForm(){
            if(!this.remember){
                this.model.VaultActionType=null
                this.model.VaultCode=null
                this.model.VaultName=null
                this.model.ProjectCode=null
                this.model.EffectiveDate=moment().format('YYYY-MM-DD')
            }
            this.model.MuhasebeKarsilikKodu=null
            this.model.MuhasebeKarsilikAdi=null
            this.model.CurrencyAmount=0
            this.model.Amount=0
            this.model.VaultDescription= null
            this.model.TMSVaultDescription= null
            this.model.PlasiyerCode=null
            this.model.PlasiyerName=null
            this.model.CurrencyType=null
            this.model.IsCurrency=null
            this.model.CurrencyRate=null
            this.model.BFormStatus=null
            this.model.BelgeTuru=null
            this.muhasebe=null
        },
        download(){
            NetsisOperationsApi.Komisyon.DownloadSample().then(res=>{
                Additional.DownloadFile(res.data, 'Komisyon Örnek Excel.xlsx')
            })
        },
        openUpload(){
            this.uploadObject.File = null
            this.$showModal('comission')
        },
        openHistory(){
            this.$showModal('comission-history')
        },
        check(){
            this.uploading = true
            const formData = new FormData()
            if(this.uploadObject.File) formData.append('File',this.uploadObject.File)
            NetsisOperationsApi.Komisyon.UploadAndCheck(formData).then(res => {
                this.uploadResult = res.data.Data
                this.$result(res)
                this.uploading = false
            }).catch(err => {
                this.uploading = false
                this.$result(null,err)
            })
        },
        done(){
            this.$hideModal('comission')
            this.saveResult = null
        },
        upload(){
            if(this.uploadResult && (this.$safe(this.uploadResult,'Datas') || []).length > 0){
                const data = {
                    VaultCode: this.model.VaultCode,
                    ValidValues: (this.$safe(this.uploadResult,'Datas') || [])
                }
                this.uploading = true


                const BankVaultTransactionTypeEnum = ['0:Muhtelif','1:Banka','2:Transfer'];
                const BankVaultTransactionStatusEnum =  ['0:Pending','1:InProgress','2:Success','3:Failed','4:Cancelled'];
                const VaultActionTypeEnum = ['0:G','1:C'];

                let multipleSendModelItems = [];

(this.$safe(this.uploadResult,'Datas') || []).forEach(item => {
    let actionType = item.Gelir_Gider == 'G' ? 0 : 1;
    let singleItem = {
        TransactionStatusNo: 0,
        TransactionStatusDescription: "Beklemede",
        RetValue: "",
        RetValueDescription: "",
        //-------------------------------
        FromVaultCode: this.model.VaultCode,
        ToVaultCode: this.model.VaultCode,
        VaultActionTypeNo: actionType,
        Amount: item.Tutar,
        AccountingTime: item.Tarih,
        AccountingCode: item.MuhasebeKodu,
        ProjectCode: item.ProjeKodu_G_R,
        VaultReportDescription: item.KasaAciklamasi,
        VaultDescription: item.MuhasebeHesapAdi,
        DocumentType: item.BelgeTuru,

    }
    multipleSendModelItems.push(singleItem)
})



let multipleSendModelMaster  =  {
        TransactionTypeNo : 0,
        TransactionStatusNo  : 0,
        TransactionStatusDescription : "Beklemede",
        UserId : Auth.UserId,
        RequestModelItems : multipleSendModelItems
    };


                VaultOperationsApi.Vault.CreateTransactionBatch(multipleSendModelMaster).then(res => {
                    if(res.data.Success){
                        this.uploadResult = null
                        this.saveResult = res.data.Data
                        this.getKasaHareketToday()
                    }
                    this.$result(res)
                    this.uploading = false
                }).catch(err => {
                    this.$result(null,err)
                    this.uploading = false
                })
            }
        },
        save(){
            this.saveLoading=true
            NetsisOperationsApi.SaveMuhtelifKasaHareket(this.model).then((res)=>{
                this.$result(res)
                this.saveLoading=false
                if(res.data.Success){
                    this.clearForm()
                    this.print({FIS_NO:res.data.Data})
                    this.getKasaHareketToday()
                }
            }).catch(err=> {
                this.saveLoading=false
                this.$result(null,err)
            })
        },
        calculateValue(){
            this.calculatedValue= this.currencyRateObj.Rate * this.model.Amount
        },
        getKasaDovizDeger(){
            this.getKasaHareketToday()
            this.pleaseWait=true
            this.model.CurrencyType = this.model.CurrencyType == null ? 0 : this.model.CurrencyType
            NetsisOperationsApi.GetNetsisCurrencyData(this.model.CurrencyType).then((res) => {
                if(res.data.Data != null){
                    this.currencyRateObj = res.data.Data
                }else{
                    this.currencyRateObj = null
                }
                this.pleaseWait=false
            }).catch(err=> {
                console.log(err)
            })
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                this.kasaList = res.data.Data
                this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
        getBelgeTurus(){
            NetsisOperationsApi.BelgeTuru.List().then(res => {
                this.belgeTurus = res.data.Data || []
            })
        },
        print(i){
            if(i.FIS_NO,i.SIRA){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.MuhtelifFis(i.FIS_NO,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        printTediye(i){
            if(i.FIS_NO && i.TIP && i.SIRA ){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.TediyeFis(i.FIS_NO,i.TIP ,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printTediyeFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        deleteHareket(i){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${i.SIRA} sıra numaralı işlemi silecektir ve geri alınamaz.`)
            .then(c => {
                if(c){
                    NetsisOperationsApi.DeleteKasaHareket(i.SIRA).then(res => {
                        this.$result(res)
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    })
                }
            }).catch(err => {
                this.$result(null,err)
            })
        },
        onPickMuhasebe(e){
            this.model.VaultDescription = e?.MuhasebeAdi||null
            this.model.MuhasebeKarsilikKodu = e?.MuhasebeKodu || null
            this.model.MuhasebeKarsilikAdi = e?.MuhasebeAdi || null
            this.muhasebe = e
        }
    },
    computed:{
        bForm:{
            get:function(){
                return this.bForms.find(s=>s.Value==this.model.BFormStatus)
            },
            set:function(value){
                this.model.BFormStatus = value?.Value || null
            }
        },
        gcType:{
            get:function(){
                return this.gcTypes.find(s=>s.Value==this.model.VaultActionType)
            },
            set:function(value){
                this.model.VaultActionType = value?.Value || null
            }
        },
        plasiyerCode:{
            get:function(){
                return this.plasiyerList.find(s=>s.PlasiyerCode==this.model.PlasiyerCode)
            },
            set:function(value){
                this.model.PlasiyerCode = value?.PlasiyerCode || null
                this.model.PlasiyerName = value?.PlasiyerName || null
            }
        },
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.model.VaultCode)
            },
            set:function(value){
                this.model.VaultCode = value?.KSMAS_KOD || null
                this.model.VaultName = value?.KSMAS_NAME || null
                this.model.CurrencyType = value?.DOVIZTIPI || null
                this.model.IsCurrency = value?.DOVIZLI || null
            }
        },
        canCreateMultiple(){
            return this.uploadResult !=null && (this.$safe(this.uploadResult,'Datas') || []).length > 0 && (this.$safe(this.uploadResult,'Errors') || []).length == 0 && this.model.VaultCode
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(s=>s.value==this.model.ProjectCode)
            },
            set:function(value){
                this.model.ProjectCode = value?.value || null
            }
        },
        reportCode:{
            get:function(){
                return this.reportCodes.find(s=>s.Code==this.model.KasaRaporKodu)
            },
            set:function(value){
                this.model.KasaRaporKodu = value?.Code || null
            }
        },
        belgeTuru:{
            get:function(){
                return this.belgeTurus.find(s=>s.Name==this.model.BelgeTuru)
            },
            set:function(value){
                this.model.BelgeTuru = value?.Name || null
            }
        }
    }
}
</script>